import React, { Component } from 'react'
import { connect } from 'react-redux'
import { filter, some } from 'lodash'
import Icon from 'components/icon/icon'
import moment from 'moment'
import { saveItem } from 'state/actions'
import AlertBanner from 'components/alerts/alert-banner'
import Button from 'components/button/button'

import Checkbox from 'components/input/checkbox'

import DashboardTimeTrackingSession from './dashboard-time-tracking-session'
import copy from 'fast-copy'

import {
	momentToApiTimeFormat,
	getSessionSeconds,
	formatByTimeZone,
	textTimeString
} from 'utils'

class DashboardTimeTracking extends Component {
	leftRef = null
	containerRef = null
	sessionDaysInReverseOrder = []

	state = {
		listHeight: 300,
		editedSessionId: null,
		tempTimeInput: '',
		currentDayIndex: 0,
		includeArchivedTasks: false
	}

	// componentDidUpdate(prevProps, prevState) {
	// 	window.requestAnimationFrame(_ => {
	// 		if(this.containerRef){
	// 			const containerHeight = this.containerRef.getBoundingClientRect().height
	// 			const offset = this.leftRef.offsetTop
	// 			const innerRefOffset = this.innerLeftRef.offsetTop

	// 			const newHeight = containerHeight - offset - innerRefOffset

	// 			if (newHeight !== this.state.listHeight) {
	// 				/*
	// 				this.setState({
	// 					listHeight: newHeight
	// 				})
	// 				*/
	// 			}
	// 		}
	// 	})

	// }

	changeDay = direction => {
		const currentIndex = this.state.currentDayIndex

		switch (direction) {
			case 'prev':
				this.setState({
					currentDayIndex: (currentIndex + 1)
				})
				break
			case 'next':
				if (currentIndex > 0) {
					this.setState({
						currentDayIndex: (currentIndex - 1)
					})
				}
				break
			case 'end':
				this.setState({
					currentDayIndex: 0
				})
				break
		}
	}

	generateSessionDaysInReverseOrder = _ => {
		const {
			sessions,
			allTasks
		} = this.props

		const {
			includeArchivedTasks
		} = this.state

		let sessionDaysInReverseOrder = []

		// remove created_at localeCompare - it's 400x slower than ID comparison. Potentially just a.date > b.date? 
		// if we allow creating new sessions on old dates, this may need to change.
		sessions.sort((a, b) => {
			return (b.created_at < a.created_at ? -1 : (b.created_at > a.created_at ? 1 : 0))
		})

		const today = moment().startOf('day')

		let hasToday = false

		sessions.forEach((session, index) => {
			if (session.deleted_at) {
				return
			}

			if (!includeArchivedTasks) {
				const task = allTasks ? allTasks[session.task_id] : null

				if (!task || !task.name) {
					return
				}
			}

			const sessionMoment = formatByTimeZone(session.created_at, null, true).startOf('day')

			// if it's empty, should push
			if (!index && sessionMoment.isSame(today)) {
				hasToday = true
			}

			let shouldPushSessionDay = false

			if (!sessionDaysInReverseOrder.length) {
				shouldPushSessionDay = true
			} else {
				let lastSessionDayMoment = sessionDaysInReverseOrder[(sessionDaysInReverseOrder.length - 1)].date

				if (sessionMoment.isSame(lastSessionDayMoment)) {
					sessionDaysInReverseOrder[(sessionDaysInReverseOrder.length - 1)].sessions.push(session)
				} else {
					shouldPushSessionDay = true
				}
			}

			if (shouldPushSessionDay) {
				sessionDaysInReverseOrder.push({
					date: sessionMoment,
					sessions: [session]
				})
			}
		})

		if (!hasToday) {
			sessionDaysInReverseOrder.unshift({
				date: today,
				sessions: []
			})
		}

		return sessionDaysInReverseOrder
	}

	getTotals = _ => {
		const {
			sessions
		} = this.props

		let totalSecondsToday = 0
		let totalSecondsThisWeek = 0
		let totalSecondsThisMonth = 0

		if (this.sessionDaysInReverseOrder.length) {
			const startOfDay = moment().startOf('day')

			some(sessions, session => {
				if (session.deleted_at) {
					return
				}

				const creationMoment = formatByTimeZone(session.created_at, null, true).startOf('day')
				const seconds = getSessionSeconds(session)

				if (creationMoment.isSame(startOfDay, 'day')) {
					totalSecondsToday += seconds
				}

				if (creationMoment.isSame(startOfDay, 'week')) {
					totalSecondsThisWeek += seconds
				}

				if (creationMoment.isSame(startOfDay, 'month')) {
					totalSecondsThisMonth += seconds
				} else {
					return true
				}
			})
		}

		return {
			day: totalSecondsToday,
			week: totalSecondsThisWeek,
			month: totalSecondsThisMonth
		}
	}

	aggregateSessions = sessionGroup => {
		const sessions = sessionGroup ? copy(sessionGroup.sessions) : []
		const newSessions = []

		sessions.forEach(session => {
			const indexIfExisting = newSessions.findIndex(newSession => {
				return newSession.task_id === session.task_id
			})

			if (indexIfExisting == -1) {
				newSessions.push(session)
			} else {
				const secondsInThisSession = getSessionSeconds(session)
				const newSessionStoppedAt = formatByTimeZone(newSessions[indexIfExisting].stopped_at, null, true)

				newSessionStoppedAt.add(secondsInThisSession, 'seconds')

				newSessions[indexIfExisting].stopped_at = momentToApiTimeFormat(newSessionStoppedAt)
			}
		})

		sessionGroup.sessions = newSessions
		return sessionGroup
	}

	toggleArchivedTasks = _ => {
		this.setState({
			includeArchivedTasks: !this.state.includeArchivedTasks
		})
	}

	render() {
		const {
			listHeight,
			currentDayIndex,
			includeArchivedTasks
		} = this.state

		const {
			allTasks,
			allProjects,
			allMilestones,
			openModal,
			isMini,
			canEdit,
			saveItem
		} = this.props

		this.sessionDaysInReverseOrder = this.generateSessionDaysInReverseOrder()

		const totals = this.getTotals()

		const thisDate = moment().startOf('day').subtract(currentDayIndex, 'days')

		let daySessionGroup = this.sessionDaysInReverseOrder.find(sessionDay => {
			return sessionDay.date.isSame(thisDate)
		})

		if (isMini) {
			daySessionGroup = this.aggregateSessions(daySessionGroup)
		}

		const isToday = moment().startOf('day').isSame(thisDate)

		const className = `widget box dashboard-time-tracking ${isMini ? 'mini' : ''}`

		return (
			<div className={className} ref={ref => this.containerRef = ref}>
				<div className="controls relative">
					<label>
						<Checkbox
							isChecked={includeArchivedTasks}
							onChange={this.toggleArchivedTasks}
						/>
						Include archived tasks
					</label>
				</div>
				<h3>
					Time tracking
				</h3>
				<div ref={ref => this.leftRef = ref}>
					<div className="left">
						<h4>
							{thisDate.format('Do MMMM')}
							<div className="header-tab-controls">
								<button
									className={'active'}
									onClick={_ => { this.changeDay('prev') }}
								>
									<Icon name="angle-left" />
									<span>
										Back
									</span>
								</button>
								<button
									className={!isToday ? 'active' : null}
									onClick={_ => { this.changeDay('end') }}
								>
									<Icon name="angle-right" />
								</button>
								<button
									className={!isToday ? 'active' : null}
									onClick={_ => { this.changeDay('next') }}
								>
									<span>
										Forward
									</span>
									<Icon name="angle-right" />
								</button>
							</div>
						</h4>
						<ul ref={ref => this.innerLeftRef = ref} style={!isMini ? {
							height: listHeight + 'px'
						} : null}>
							{(!daySessionGroup || !daySessionGroup.sessions.length) &&
								<AlertBanner
									low={false}
									title={`No times tracked ${ isToday ? 'today' : 'on this date'}.`}
									body={canEdit ? "When you've tracked some times, they'll show up here." : `There's nothing to show here.`}
								/>
							}
							{daySessionGroup && daySessionGroup.sessions.map(session => {
								return (
									<DashboardTimeTrackingSession
										session={session}
										allMilestones={allMilestones}
										allProjects={allProjects}
										allTasks={allTasks}
										key={session.id}
										openModal={openModal}
										canEdit={canEdit}
										saveItem={saveItem}
									/>
								)
							})}
							<Button
								size={'big'}
								level={'low'}
								callback={_ => {
									openModal('add-time', 'session', {
										date: thisDate
									})
								}}
								label={'Add manual time'}
								icon={'fe-clock'}
							/>
						</ul>
					</div>
					{!isMini &&
						<div className="right">
							<label>
								Today:
							</label>
							<span className="time-figure">
								{textTimeString(totals.day, 'seconds', true)}
							</span>
							<label>
								This week:
							</label>
							<span className="time-figure">
								{textTimeString(totals.week, 'seconds', true)}
							</span>
							<label>
								{thisDate.format('MMMM')}:
							</label>
							<span className="time-figure">
								{textTimeString(totals.month, 'seconds', true)}
							</span>
						</div>
					}
				</div>
			</div>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		sessions: state.account.entities.sessions ? filter(state.account.entities.sessions, session => {
			return session.user_id === ownProps.userData.id
		}) : [],
		allTasks: state.account.entities.tasks
	}
}

export default connect(mapStateToProps, {
	saveItem,
})(DashboardTimeTracking)



// WEBPACK FOOTER //
// ./src/sections/dashboard/dashboard-time-tracking.jsx